module.exports = __webpack_public_path__ + "static/media/music.e0729aa3.mp3";